import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  trigger,
  state,
  query,
  style,
  animate,
  transition,
  keyframes
} from '@angular/animations';


@Component({
  selector: 'pages-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
      trigger('flyIn', [
      state('in', style({transform: 'translateX(0)'})),
      transition('void => *', [
        animate(500, keyframes([
          style({opacity: 0, transform: 'translateX(-100%)', offset: 0}),
          style({opacity: 1, transform: 'translateX(15px)',  offset: 0.3}),
          style({opacity: 1, transform: 'translateX(0)',     offset: 1.0})
        ]))
      ]),
    ])
  ]
})

export class PagesHomeComponent implements OnInit {
  animate;

  constructor() { }

  ngOnInit() {
    setTimeout(() => this.animate = 'flyIn', 3000);
  }
  ngOnDestroy() {}

}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts